/**
 * @description Base class for all states.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export abstract class BaseState<T> {
	private static instances = new Map<string, BaseState<unknown>>();

	protected constructor() {}

	static getInstance<S extends BaseState<S>>(stateClass: new () => S): S {
		const className = stateClass.name;
		if (!this.instances.has(className)) {
			this.instances.set(className, new stateClass());
		}
		return this.instances.get(className) as S;
	}
}
